export default {
  'items-per-page-options': [5, 10, 15, 25, 50, 100, 250],
  'show-first-last-page': true,
  'first-icon': '$chevron_double_left',
  'last-icon': '$chevron_double_right',
  'prev-icon': '$chevron_left',
  'next-icon': '$chevron_right'
}
